// import { fetchAuditTrailApi } from "../../../../api/ViewproductApi";
// import { useEffect, useState } from "react";
// import CustomTable from "../../../controls/CustomTable";
// import Loading from "../../../controls/Loading";
// import { toast } from "react-toastify";

// const ProductAuditTrial = ({ productData }) => {
//     const [tableData, setTableData] = useState([]);
//     const [loading, setLoading] = useState(false);


//     useEffect(() => {

//         fetchData(productData.key);
//     }, []);

//     const fetchData = async (key) => {
//         setLoading(true); // Start loading
//         try {
//             const data = await fetchAuditTrailApi(key);
//             console.log("data in Audit trail ", data);
//             setTableData(data.auditTrails);
//         } catch (error) {
//             toast.error("Failed to load data !");
//         } finally {
//             setLoading(false); // Stop loading
//         }
//     };

//     // Columns for the table
//     const columns = [
//         { field: "Date", headerName: "Date & Time" },
//         { field: "Action", headerName: "Action Performed" },
//         { field: "ActionBy", headerName: "Action By" }
//     ];


//     const rows = tableData.map((item) => {
//         const date = new Date(item.ActionOn._seconds * 1000); // Convert _seconds to milliseconds
//         const day = date.getDate();
//         const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][date.getMonth()];
//         const year = date.getFullYear();
//         const hours = String(date.getHours()).padStart(2, '0'); // Ensure 2 digits for hours
//         const minutes = String(date.getMinutes()).padStart(2, '0'); // Ensure 2 digits for minutes
//         const seconds = String(date.getSeconds()).padStart(2, '0'); // Ensure 2 digits for seconds
    
//         return {
//             Action: item.Action || "N/A",
//             ActionBy: item.ActionBy || "N/A",
//             Date: `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}` || "N/A", // Full date with time
//         };
//     });
    

//     return (
//         <>
//             <div className="flex-1 p-4">
//                 {loading && <Loading />} 
//                 {!loading && rows.length > 0 &&<div className="w-full"> <CustomTable columns={columns} rows={rows} /> </div> }
//                 {!loading && rows.length === 0 && (
//                     <div className=" items-center justify-center flex" style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}>No Data Available!</div>
//                 )}
//             </div>
//         </>
//     );
// };

// export default ProductAuditTrial;




import { fetchAuditTrailApi } from "../../../../api/ViewproductApi";
import { useEffect, useState } from "react";
import CustomTable from "../../../controls/CustomTable";
import Loading from "../../../controls/Loading";
import { toast } from "react-toastify";
import AuditTrail from "../../../controls/AuditTrail";

const ProductAuditTrial = ({ productData }) => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {

        fetchData(productData.key);
    }, []);

    const fetchData = async (key) => {
        setLoading(true); // Start loading
        try {
            const data = await fetchAuditTrailApi(key);
            console.log("data in Audit trail ", data);
            setTableData(data.auditTrails);
        } catch (error) {
            toast.error("Failed to load data !");
        } finally {
            setLoading(false); // Stop loading
        }
    };

    
    

    return (
        <div className="p-4">
            <AuditTrail data={tableData} loading={loading}/>
        </div>
    );
};

export default ProductAuditTrial;
